/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PrivatePhotoStatus {
    REQUESTED = 'REQUESTED',
    SHARED = 'SHARED',
    HIDDEN = 'HIDDEN',
    NONE = 'NONE',
}
